import Immutable from 'immutable';

export default ({$$data, $$subscriptions}) => {
  let liveEvents = undefined;
  if ($$subscriptions !== undefined && $$subscriptions.size > 0) {
    liveEvents = $$data.get('myfutureevents').sortBy(e => e.get('eventDate')).filter(e => $$subscriptions.contains(e.get('id')) && e.get('eventState') === 'live')
  }
  const $$liveEvent = liveEvents !== undefined && liveEvents.size > 0 ? liveEvents.get(0) : undefined;
  if ($$liveEvent !== undefined) return $$liveEvent;
  else if ($$data.get('myfutureevents') !== undefined ) return $$data.get('myfutureevents').get(0);
  else return undefined;
}



// WEBPACK FOOTER //
// ./src/helpers/getLiveEvent.jsx